import { useTranslation } from "react-i18next"

import { useLatency } from "./latencyHistory.state"

export const Latency = () => {
  const { t } = useTranslation()
  const latency = useLatency()

  return latency ? (
    <p className="mr-2 text-sm-regular">
      {t("stats.uiLatency", { latency })}
      <span>{t("stats.milliSecondsAbbr")}</span>
    </p>
  ) : null
}
